module.exports = "https://web-assets.ifttt.com/packs/media/privacy/quotes-4534467f.svg";